import { generatePath, type RouteObject } from "react-router-dom";

export type WorkOrderRouteParams = {
    workOrderId: string;
};

export const workOrdersPath = "/work-orders";

export const workOrderPath = "/work-orders/:workOrderId";

export const workOrderPathFor = (params: WorkOrderRouteParams) => generatePath(workOrderPath, params);

export const workOrdersRoutes: RouteObject[] = [
    {
        path: workOrdersPath,
        lazy: async () => {
            const { WorkOrdersPage } = await import("@/features/workOrders/page");
            return { Component: WorkOrdersPage };
        },
    },
    {
        path: workOrderPath,
        lazy: async () => {
            const { WorkOrderDetailPage } = await import("@/features/workOrders/page");
            return { Component: WorkOrderDetailPage };
        },
    },
];
